import { Directive, Input, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[appPlaceholder]',
  standalone: false,
})
export class PlaceholderDirective implements OnInit {
  private element = inject(ElementRef);

  @Input() appPlaceholder: string;

  ngOnInit() {
    this.element.nativeElement.setAttribute('placeholder', this.appPlaceholder);
  }
}
